import logo from "../resources/logo_neu.png"
import TopMenuItem from "../component/TopMenuItem"
import { NAVIGATION_VIEW } from "../navigation/NavigationController"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    logoutProfessional,
    selectProfessionalAuthenticationState
} from "../redux/ProfessionalAuthentication"
import { useNavigate } from "react-router-dom"
import {
    blurTopMenu,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../redux/Onboarding"
import MobileAlternative from "../component/MobileAlternative"
import MobileTopMenu from "./MobileTopMenu"
import { selectDashboardSelectedPatient } from "../redux/ProfessionalDashboard"
import notNull from "../util/notNull"
import OnboardingStep from "../onboarding/OnboardingStep"

function TopMenu() {
    const dispatch = useAppDispatch()
    const authenticated = useAppSelector(selectProfessionalAuthenticationState)
    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const onboardingStep = useAppSelector(selectOnboardingStep)

    const navigate = useNavigate()

    const dashboardMode = false

    const patient = useAppSelector(selectDashboardSelectedPatient)

    return (
        <MobileAlternative>
            <MobileTopMenu />
            <div
                className={
                    "h-[40px] flex items-center shadow w-full " +
                    (blurTopMenu(onboardingIsRunning, onboardingStep)
                        ? "blur"
                        : "")
                }>
                <div
                    onClick={() => navigate("/")}
                    className={
                        "ml-3 text-2xl cursor-pointer text-black font-bold"
                    }>
                    <img src={logo} height={90} width={90} />
                </div>
                <div className={"ml-auto mr-3 space-x-4 flex"}>
                    {!authenticated ? (
                        <>
                            <TopMenuItem location={NAVIGATION_VIEW.HOME}>
                                Startseite
                            </TopMenuItem>
                            <TopMenuItem location={NAVIGATION_VIEW.SIGN_IN}>
                                Anmelden
                            </TopMenuItem>
                            <TopMenuItem location={NAVIGATION_VIEW.SIGN_UP}>
                                Registrieren
                            </TopMenuItem>
                        </>
                    ) : (
                        <>
                            {!dashboardMode && (
                                <>
                                    <TopMenuItem
                                        location={
                                            NAVIGATION_VIEW.PATIENT_SELECTION_VIEW
                                        }>
                                        Patient:innen-Auswahl
                                    </TopMenuItem>
                                    {notNull(patient) && (
                                        <>
                                            <TopMenuItem
                                                location={
                                                    NAVIGATION_VIEW.PATIENT_DETAIL_VIEW
                                                }>
                                                Datenansicht
                                            </TopMenuItem>
                                            <TopMenuItem
                                                location={
                                                    NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_PREDICTION
                                                }>
                                                Vorhersage
                                            </TopMenuItem>
                                            <TopMenuItem
                                                location={
                                                    NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_MEDICATION
                                                }>
                                                Medikation
                                            </TopMenuItem>
                                            <TopMenuItem
                                                location={
                                                    NAVIGATION_VIEW.PATIENT_SETTINGS_VIEW
                                                }>
                                                Einstellungen
                                            </TopMenuItem>
                                        </>
                                    )}
                                </>
                            )}
                            {dashboardMode && (
                                <>
                                    <TopMenuItem
                                        location={
                                            NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD
                                        }>
                                        Datenansicht
                                    </TopMenuItem>
                                    <TopMenuItem
                                        location={
                                            NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_REPORT
                                        }>
                                        Berichtansicht
                                    </TopMenuItem>
                                    <TopMenuItem
                                        location={
                                            NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_MEDICATION
                                        }>
                                        Medikationsansicht
                                    </TopMenuItem>
                                </>
                            )}
                            <TopMenuItem
                                onClick={() => {
                                    dispatch(logoutProfessional())
                                    navigate("/")
                                }}
                                action={true}
                                onboarding={
                                    onboardingStep ===
                                    OnboardingStep.SHOW_NAV_LOGOUT
                                }
                                location={NAVIGATION_VIEW.HOME}>
                                Logout
                            </TopMenuItem>
                        </>
                    )}
                </div>
            </div>
        </MobileAlternative>
    )
}

export default TopMenu
